import styled from 'styled-components';

export const CSSTitleAccessor = styled.a`
    flex: 1;
    flex-direction: row;
    display: flex;
    padding: 10px;
    cursor: pointer;
    gap: 10px;

    &:hover {
        text-decoration: none;
    }
`;

export const CSSTitle = styled.div`
    justify-content: center;
    display: flex;
    flex-direction: column;
`;

export const CSSSubTitle = styled.div`
    font-size: 11px;
    color: ${(props) => props.theme.color.grey4};
`;

export const CSSDocument = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    &:hover {
        background-color: ${(props) => props.theme.color.grey0};
    }
`;

export const CSSDocumentTitle = styled.div`
    flex: 1;
`;

export const CSSDocumentOption = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CSSActionElements = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
`;

export const CSSIconAccessor = styled.div`
    width: 40px;
    align-items: center;
    display: flex;
    justify-content: center;
`;

export const CSSActionAccessor = styled.div`
    align-items: flex-end;
    display: flex;
    flex: 1;
    justify-content: flex-end;
`;

export const ListWrapper = styled.div`
    overflow: auto;
`;

export const CSSEmptyWrapper = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: center;
    min-height: 100px;
`;

export const CSSOpacityFilter = styled.div<{ opacity?: number }>`
    opacity: ${(props) => props.opacity};
`;

export const CSSPool = styled.div`
    overflow: auto;
`;

export const CSSListNoHead = styled.div`
    thead {
        display: none;
    }
`;

export const CSSLoader = styled.div`
    padding: 24px;
    justify-content: center;
    align-items: center;
`;
